import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";
import { Upload, DollarSign, BarChart3, ShieldCheck, ArrowRight } from "lucide-react";

const STEPS = [
  { icon: <Upload className="w-6 h-6" />, t: "Upload your catalogue", d: "Add movies and multi-episode TV shows in full 1080p HD and 4K with posters, captions and subtitles." },
  { icon: <DollarSign className="w-6 h-6" />, t: "Set your own prices", d: "Choose rent and buy prices per title or per episode. Defaults are $3 rent (3 days) and $15 to buy." },
  { icon: <BarChart3 className="w-6 h-6" />, t: "Track every sale", d: "See which account bought or rented each title (email only — never passwords) and your real-time earnings." },
];

export default function Distributors() {
  useSeo({ title: "Sell on Mandalay+ — Distributors", description: "Distribute your Burmese movies and TV shows on Mandalay+. Set your own rent/buy prices and reach a premium audience." });
  return (
    <div className="bg-ink min-h-screen pt-24 px-4 sm:px-12 pb-20">
      <div className="max-w-4xl mx-auto text-center animate-fade-up">
        <span className="text-xs tracking-[0.2em] uppercase font-semibold text-gold">For content owners & distributors</span>
        <h1 className="font-display text-4xl sm:text-6xl font-black mt-3 mb-4">Sell your films & series on <span className="text-gold">Mandalay+</span></h1>
        <p className="text-white/70 max-w-2xl mx-auto mb-8">Reach a premium audience of Burmese movie & TV lovers. You keep control of your pricing — we handle streaming, payments and content protection.</p>
        <Link to="/distributor/signup" data-testid="become-distributor-btn" className="inline-flex items-center gap-2 bg-gold text-black font-semibold px-7 py-3 rounded-md hover:bg-gold/90 transition-colors">
          Become a Distributor <ArrowRight className="w-5 h-5" />
        </Link>
      </div>

      <div className="grid md:grid-cols-3 gap-5 max-w-5xl mx-auto mt-16">
        {STEPS.map((s) => (
          <div key={s.t} className="bg-surface border border-white/10 rounded-2xl p-6">
            <div className="w-12 h-12 rounded-lg bg-gold/15 text-gold flex items-center justify-center mb-4">{s.icon}</div>
            <h3 className="font-display text-xl font-bold mb-2">{s.t}</h3>
            <p className="text-white/60 text-sm">{s.d}</p>
          </div>
        ))}
      </div>

      <div className="max-w-3xl mx-auto mt-14 bg-surface border border-white/10 rounded-2xl p-6 flex items-start gap-4">
        <ShieldCheck className="w-7 h-7 text-gold shrink-0 mt-1" />
        <div>
          <h3 className="font-display text-lg font-bold mb-1">Transparent commission</h3>
          <p className="text-white/60 text-sm">Platform commission is 30% for the first 6 months a title is listed, 20% from 6–12 months, and just 10% after 12 months. By listing, you grant Mandalay+ rights to host and promote your content. Full terms on the <Link to="/terms" className="text-gold underline">Terms &amp; Conditions</Link> page.</p>
        </div>
      </div>
    </div>
  );
}
